import { useContext, useEffect, useRef, useState } from 'react'
import { columnsheadId } from '../../universal/columnshead';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import DimSumHistoryEdit from './DimSumHistoryEdit';
import { SocketContext } from '../../../App';
import { Button, Space } from 'antd';
import WarehouseToMenu from './WarehouseToMenu';
import ShowDimSum from './ShowDimSum';
import dayjs from 'dayjs';

export default function DimSumHistory(props: any) {

    const ref = useRef<any>(undefined);

    //添加菜式窗口
    const [menuToDimSumVisible, setMenuToDimSumVisible] = useState(false);

    //添加菜式数据
    const [menuToDimSumData, setMenuToDimSumData] = useState<any>();

    //查看菜式窗口
    const [showDimSumVisible, setShowDimSumVisible] = useState(false);

    //查看菜式数据
    const [dimSumData, setDimSumData] = useState<any>();

    /** api服务id */
    const apiId = 'dimSumHistory';

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const onRefresh = (item: any) => {
        const { branchStoreId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                branchStoreId
            }
        }
        ref.current.initData(currentData);
        setContextData({ ...contextData, refresh: false })
    }

    //添加菜式
    const handleAddMenu = (record: any) => {

        sendData.key = 'branchStoreMenuWarehouseToDimSum';
        sendData.dimSumHistoryId = record.id;
        sendData.dimSumHistoryName = record.dimSumHistoryName;
        sendData.brandId = record.branchStore.brand.brandId;
        sendData.brandName = record.branchStore.brand.brandName;
        sendData.branchStoreId = record.branchStoreId;
        sendData.branchStoreName = record.branchStore.branchStoreName;

        setMenuToDimSumData(sendData);
        setMenuToDimSumVisible(true);
    };

    //关闭穿梭框页面
    const onCloseMenuToDimSum = () => {
        setMenuToDimSumVisible(false);
        // if (status) {
        //     await initData();
        // }
    }

    //打开查看菜式
    const handleShowDimSum = (record: any) => {
        // console.log(record);

        sendData.dimSumHistoryId = record.id;
        sendData.dimSumHistoryName = record.dimSumHistoryName;
        sendData.brandId = record.branchStore.brand.brandId;
        sendData.brandName = record.branchStore.brand.brandName;
        sendData.branchStoreId = record.branchStoreId;
        sendData.branchStoreName = record.branchStore.branchStoreName;
        sendData.startTime = record.startTime;
        sendData.endTime = record.endTime;

        setDimSumData(sendData);
        setShowDimSumVisible(true);
    };

    //表头
    const columnsHead = [
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                )
            }
        },
        {
            title: '名称',
            dataIndex: 'dimSumHistoryName',
        },
        {
            title: '添加菜式',
            dataIndex: 'addMenu',
            key: 'addMenu',
            render: (text: any, record: any) => {
                return <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleAddMenu(record)}>添加菜式</Button>
                </Space>
            }
        },
        {
            title: '查看菜式',
            dataIndex: 'showMenu',
            key: 'showMenu',
            render: (text: any, record: any) => {
                return <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleShowDimSum(record)}>查看菜式</Button>
                </Space>
            }
        },
        {
            title: '备注',
            dataIndex: 'memo',
        },
        {
            title: '开始时间',
            dataIndex: 'startTime',
            render: (text: any, record: any) => {
                return (
                    <div>{dayjs(record.startTime).format("YYYY-MM-DD")}</div>
                )
            }
        },
        {
            title: '结束时间',
            dataIndex: 'endTime',
            render: (text: any, record: any) => {
                return (
                    <div>{dayjs(record.endTime).format("YYYY-MM-DD")}</div>
                )
            }
        },
    ];

    //传关参数
    let sendData = {
        type: 'EDIT',
        key: '',
        dimSumHistoryId: '',
        dimSumHistoryName: '',
        brandId: '',
        brandName: '',
        branchStoreId: '',
        branchStoreName: '',
        startTime:'',
        endTime:''
    }

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '点心单',
        apiId: 'dimSumHistory',
        // showStates: true,
        columns,
        pagination: true,
        sendPageData: { branchStoreId: contextData?.currentBranchStoreId },
        extendIdName: "branchStoreId",
        EditComponent: DimSumHistoryEdit,
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref} />

            {menuToDimSumVisible
                ? (<WarehouseToMenu
                    closeModal={onCloseMenuToDimSum} data={menuToDimSumData} />)
                : null}

            {showDimSumVisible
                ? (<ShowDimSum
                    closeModal={setShowDimSumVisible} data={dimSumData} />)
                : null}
        </>
    )
}